import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers';
import { useAlertStore } from '..';

const baseUrl = `${process.env.VUE_APP_VUE_API_URL}`;

// One "update" = a release: backend, sync and frontend move together to the
// same branch/tag/commit; one rollback puts all of them back.
export const useAdminDeployStore = defineStore('admin-deploy', {
    state: () => ({
        apps: {},          // app -> what runs now (commit, pm2 status …)
        release: null,     // { busy, last, history, job }
        refs: null,        // { branches:[{name, apps:{app:short}, in_all}], tags:[…] }
        plan: null,        // { ref, ok, changes:[app], apps:{app:{sha, target, changed …}} }
        loading: false,
        planning: false,
    }),
    actions: {
        async loadState() {
            const alertStore = useAlertStore();
            this.loading = true;
            try {
                const [s, r] = await Promise.all([
                    fetchWrapper.get(`${baseUrl}/admin/deploy/state`),
                    fetchWrapper.get(`${baseUrl}/admin/deploy/release/state`),
                ]);
                this.apps = s.apps || {};
                this.release = r;
            } catch (error) {
                alertStore.error(error);
            } finally {
                this.loading = false;
            }
        },
        async loadRefs() {
            const alertStore = useAlertStore();
            try {
                this.refs = await fetchWrapper.get(`${baseUrl}/admin/deploy/release/refs`);
            } catch (error) {
                alertStore.error(error);
            }
        },
        async loadPlan(ref) {
            const alertStore = useAlertStore();
            this.planning = true;
            try {
                this.plan = await fetchWrapper.get(`${baseUrl}/admin/deploy/release/plan?ref=${encodeURIComponent(ref)}`);
            } catch (error) {
                this.plan = null;
                alertStore.error(error);
            } finally {
                this.planning = false;
            }
            return this.plan;
        },
        async startRelease(ref) {
            const res = await fetchWrapper.post(`${baseUrl}/admin/deploy/release/run`, { ref });
            return res.job;
        },
        async startRollback() {
            const res = await fetchWrapper.post(`${baseUrl}/admin/deploy/release/rollback`, {});
            return res.job;
        },
        async startRestore(id) {
            const res = await fetchWrapper.post(`${baseUrl}/admin/deploy/release/restore`, { id });
            return res.job;
        },
        // what is being updated right now (any app, from this page or the command line); never alerts,
        // because the backend is briefly away while it restarts itself
        async activity() {
            const res = await fetchWrapper.get(`${baseUrl}/admin/deploy/activity`);
            return res.running || [];
        },
        async job() {
            const res = await fetchWrapper.get(`${baseUrl}/admin/deploy/job?app=release`);
            return res.job;
        },
    },
});
